import { VendorData } from './Vendor';
import { VendorItemData } from './VendorItem';

export enum PurchaseOrderStatus {
  Draft = 'DRAFT',
  Unconfirmed = 'UNCONFIRMED',
  Sent = 'SENT',
  Confirmed = 'CONFIRMED',
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
}

export interface PurchaseOrdersGridRowResponse {
  [key: string]: unknown;
  id: string;
  vendor: VendorData;
  vendorId: string;
  poNumber: string;
  orderDate: string;
  deliveryDate: string;
  status: PurchaseOrderStatus;
  orderTotal: number;
}

export interface PreviousPurchaseOrder {
  id: string;
  purchaseOrder: {
    id: string;
    orderDate: string;
  };
  orderQty: number;
  receivingUnitId: string;
  vendorItemId: string;
}

export interface PurchaseOrderItem {
  [key: string]: unknown;
  id: string;
  purchaseOrderId: string;
  itemCode: string;
  itemName: string;
  vendorItem: VendorItemData | null;
  purchaseUnit: {
    id: string;
    name: string;
    abbreviation: string;
  };
  orderQty: number;
  price: number;
  extendedTotalAmount: number;
  suggestedQty: number;
  requiredQty: number;
  currentOnHand: number;
  openPO: number;
  vendorItemId: string;
  recentOrders: PreviousPurchaseOrder[];
}

export interface PreviousOrder {
  orderDate: string;
  orderQty: number;
  id: string;
}

export interface VendorItemPurchaseOrderDetails {
  recentOrders: PreviousOrder[];
  currentOnHand: number;
  suggestedQty: number;
  requiredQty: number;
  itemCode: string;
  itemName: string;
  openPO: number;
  vendorItem: VendorItemData;
  vendorItemId: string;
}

export interface PurchaseOrderVendorDetails {
  name: string;
  email: string;
}

export interface PurchaseOrderAcknowledgementDetails {
  id: string;
  poNumber: string;
  status: PurchaseOrderStatus;
  canAcknowledge: boolean;
}

export interface PurchaseOrderDetails {
  id: string;
  vendor: VendorData;
  vendorContact: PurchaseOrderVendorDetails;
  updatedAt: string;
  updatedBy: string;
  poNumber: string;
  orderTotal: number;
  orderDate: string;
  deliveryDate: string;
  status: PurchaseOrderStatus;
  notes: string;
}

export interface VendorContactDto {
  name?: string;
  email?: string;
}

export interface CreatePurchaseOrderDto {
  poNumber?: string;
  orderDate: string;
  deliveryDate: string;
  vendorId: string;
  vendorContact?: VendorContactDto | null;
  orderTotal: number;
  notes?: string;
}

export interface CreatePurchaseOrderItemDto {
  vendorItemId: string;
  orderQty: number;
}

export interface UpdatePurchaseOrderItemDto {
  orderQty: number;
}

export interface GeneratePoNumberRequestDto {
  vendorId: string;
}

export interface GeneratePoNumberResponseDto {
  poNumber: string;
  format: string;
  dateComponent: string;
  vendorNameComponent: string;
  sequenceComponent: string;
}

export interface CreateSuggestedPurchaseOrderDto {
  poNumber?: string;
  orderDate?: string;
  deliveryDate?: string;
  vendorId: string;
  vendorContact?: VendorContactDto | null;
  orderTotal?: number;
  notes?: string;
}

export interface CreateSuggestedPurchaseOrderResponseDto {
  purchaseOrderId: string;
}
